import { render, staticRenderFns } from "./sixones.vue?vue&type=template&id=d21f6784&scoped=true&"
import script from "./sixones.vue?vue&type=script&lang=js&"
export * from "./sixones.vue?vue&type=script&lang=js&"
import style0 from "./sixones.vue?vue&type=style&index=0&id=d21f6784&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21f6784",
  null
  
)

export default component.exports